import {Injectable} from '@angular/core';
import {Model} from '../../app.model';
import {HttpClient} from "@angular/common/http";
import {map, take} from "rxjs/operators";
import {OrderService} from "../../order/order.service";
import {SaleOrder} from '../../buy/buy.model';
import {Tariff, TariffFlatOffer} from '../../tariff/tariff.model';

@Injectable()
export class WorkflowEndcustomerService {

  private readonly url = 'services/workflow';

  constructor(private m: Model, private http: HttpClient, private saleOrderService: OrderService) {
  }

  public oneApplianceCuChange(applianceId: string, cu: number) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/cu/change`, {
      cu
    }).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneApplianceSlaChange(applianceId: string, sla: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/sla/change`, {
      sla
    }).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneTrialCreateOrder(data: { instance_name: string, acquire_phone_number?: string }) {
    return this.http.post<any>(`${this.url}/one-trial/appliance/create`, data)
      .pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneTrialAddPhonenumber(applianceId: string) {
    return this.http.post<any>(`${this.url}/one-trial/appliance/${applianceId}/add-number`, {});
  }

  public oneApplianceAddPremium(applianceId: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/premium/add`, {}).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneApplianceCancelPremium(saleOrder: string) {
    return this.http.post<any>(`services/subscriptions/order/${saleOrder}/cancel`, {});
  }

  public oneApplianceDowngradePremium(applianceId: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/premium/cancel`, {}).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public createTariffOffer(tariffFlatOffer: TariffFlatOffer, appliance_id: string) {
    return this.http.post<SaleOrder>(`${this.url}/one/appliance/${appliance_id}/flat/change`, tariffFlatOffer).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneApplianceCancelTariffOrder(saleOrder: string) {
    return this.http.post<any>(`services/subscriptions/order/${saleOrder}/cancel`, {});
  }

  public oneApplianceCreateCancelPhonenumberOrder(applianceId: string, blockId: number) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/block/cancel`, { "block_id": blockId}).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }
}
